import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Component", "children", "key"];
import { useSelectedObjectTypeDef } from '../../crmObjects/hooks/useSelectedObjectTypeDef';
import { useHasAllScopes } from '../../auth/hooks/useHasAllScopes';
import { useHasAllGates } from '../../auth/hooks/useHasAllGates';
import { useLegacyPageType } from '../../views/hooks/useLegacyPageType';
import { useCurrentViewId } from '../../views/hooks/useCurrentViewId';
import { jsx as _jsx } from "react/jsx-runtime";
const BehaviorRenderer = _ref => {
  let {
      Component,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const typeDef = useSelectedObjectTypeDef();
  const hasAllScopes = useHasAllScopes();
  const hasAllGates = useHasAllGates();
  const pageType = useLegacyPageType();
  const viewId = useCurrentViewId();
  if (!Component) {
    return null;
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({}, rest, {
    typeDef: typeDef,
    hasAllScopes: hasAllScopes,
    hasAllGates: hasAllGates,
    pageType: pageType,
    viewId: viewId,
    children: children
  }));
};
export default BehaviorRenderer;